import { apiHelper } from './api_helper';

export const SALESET_REGISTER_DICHVU_API_END_POINT = "sf-saleset-register-dichvu";
export const saleSetRegisterDichVuApi = {
  SelectAll: () => apiHelper.get(`${SALESET_REGISTER_DICHVU_API_END_POINT}`),
  SelectByCoSo: (data) => apiHelper.post(`sf-saleset-register-dichvu/select/by/coso`,data),
  Detail: (id) => apiHelper.get(`${SALESET_REGISTER_DICHVU_API_END_POINT}/${id}`),
  Insert: (data) => apiHelper.post(`${SALESET_REGISTER_DICHVU_API_END_POINT}`, data),
  InsertMultiple: (data) => apiHelper.post(`sf-saleset-register-dichvu/insert-multiple`, data),
  InsertMultipleByNamHoc: (data) => apiHelper.post(`sf-saleset-register-dichvu/insert-multiple-by-namhoc`, data),
  Update: (data) => apiHelper.put(`${SALESET_REGISTER_DICHVU_API_END_POINT}`, data),
  Delete: (id) => apiHelper.delete(`${SALESET_REGISTER_DICHVU_API_END_POINT}/${id}`),
}